<template>
    <div class="home" id="home">
        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <img src="@/static/music.png" :class="music ? 'music zhuan' : 'music'" @click="stopmusic" alt="" />
        <img src="../static/homebg.jpg" class="homebg" alt="">

        <img src="../static/title.png" class="title" alt="">
        <img src="../static/tobottom.gif" class="tobottom" alt="">
        <img src="../static/tips.png" class="tips" alt="">
        <img src="../static/tips2.png" class="tips2" alt="">

        <img src="../static/p1.png" class="p1" v-show="p1" alt="">
        <img src="../static/p2.png" class="p2" v-show="p2" alt="">

        <img src="../static/p3.png" class="p3" v-show="p3" alt="">
        <img src="../static/p4.png" class="p4" v-show="p4" alt="">

        <img src="../static/tips3.png" class="tips3" v-show="tips1" alt="">
        <img src="../static/p5.png" class="p5" v-show="p5" alt="">
        <img src="../static/p6.png" class="p6" v-show="p6" alt="">
        <img src="../static/tips4.png" class="tips4" v-show="tips2" alt="">
        <img src="../static/p7.png" class="p7" v-show="p7" alt="">
        <img src="../static/p8.png" class="p8" v-show="p8" alt="">
        <img src="../static/p9.png" class="p9" v-show="p9" alt="">
        <img src="../static/tips5.png" class="tips5"  v-show="tips3" alt="">

        <img src="../static/p10.png" class="p10" v-show="p10" alt="">
        <img src="../static/p11.png" class="p11" v-show="p11" alt="">
        <img src="../static/p12.png" class="p12" v-show="p12" alt="">

        <img src="../static/tips6.png" class="tips6" v-show="tips4" alt="">
        <img src="../static/tips7.png" class="tips7" v-show="tips5" alt="">
        <img src="../static/p13.png" class="p13" v-show="p13" alt="">
        <img src="../static/p14.png" class="p14" v-show="p14" alt="">
        <img src="../static/tips8.png" class="tips8" v-show="tips6" alt="">

        <img src="../static/p15.png" class="p15" v-show="p15" alt="">
        <img src="../static/p16.png" class="p16" v-show="p16" alt="">
        <img src="../static/tips9.png" class="tips9" v-show="tips7" alt="">

        <img src="../static/p17.png" class="p17" v-show="p17" alt="">
        <img src="../static/p18.png" class="p18" v-show="p18" alt="">
        <img src="../static/tips10.png" class="tips10" v-show="tips8" alt="">

        <img src="../static/p19.png" class="p19" v-show="p19" alt="">
        <img src="../static/tips11.png" class="tips11" v-show="tips9" alt="">

        <img src="../static/p20.png" class="p20" v-show="p20" alt="">
        <img src="../static/p21.png" class="p21" v-show="p21" alt="">
        <img src="../static/tips12.png" class="tips12" v-show="tips10" alt="">

        <img src="../static/p22.png" class="p22" v-show="p22" alt="">
        <img src="../static/tips13.png" class="tips13" v-show="tips11" alt="">
        <img src="../static/p23.png" class="p23" v-show="p23" alt="">
        <img src="../static/tips14.png" class="tips14" v-show="tips12" alt="">

        <img src="../static/tips15.png" class="tips15" v-show="tips13" alt="">
        <img src="../static/p24.png" class="p24" v-show="p24" alt="">
        <img src="../static/tips16.png" class="tips16" v-show="tips14" alt="">
        <img src="../static/tips17.png" class="tips17" v-show="tips15" alt="">
        <img src="../static/p25.png" class="p25" v-show="p25" alt="">
        <img src="../static/p26.png" class="p26" v-show="p26" alt="">
        <img src="../static/p27.png" class="p27" v-show="p27" alt="">

        <img src="../static/p28.png" class="p28" v-show="p28" alt="">
        <img src="../static/p29.png" class="p29" v-show="p29" alt="">
        <img src="../static/p30.png" class="p30" v-show="p30" alt="">
    </div>
</template>

<script>
export default {
    data() {
        return {
            music: true,
            p1: false,
            p2: false,
            p3: false,
            p4: false,
            p5: false,
            p6: false,
            p7: false,
            p8: false,
            p9: false,
            p10: false,
            p11: false,
            p12: false,
            p13: false,
            p14: false,
            p15: false,
            p16: false,
            p17: false,
            p18: false,
            p19: false,
            p20: false,
            p21: false,
            p22: false,
            p23: false,
            p24: false,
            p25: false,
            p26: false,
            p27: false,
            p28: false,
            p29: false,
            p30: false,
            tips1: false,
            tips2: false,
            tips3: false,
            tips4: false,
            tips5: false,
            tips6: false,
            tips7: false,
            tips8: false,
            tips9: false,
            tips10: false,
            tips11: false,
            tips12: false,
            tips13: false,
            tips14: false,
            tips15: false,
        }

    },
    methods: {
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();

            } else {
                this.music = true;
                // audio.volume = 0.2;
                audio.play();
            }
        },
        scrolling() {
            // 滚动条距文档顶部的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            this.thescrollTop = scrollTop
            // 滚动条滚动的距离
            let scrollStep = scrollTop - this.oldScrollTop;
            console.log("header 滚动距离 ", scrollTop);
            if (scrollTop > 0) {
                if (this.music) {
                    document.getElementById('audio').volume = 0.8;
                    document.getElementById('audio').play();
                }
            }
            // if (this.music == true) {
            //     document.getElementById("audio").play() 

            // }

            let bl = document.getElementById("home").offsetWidth / 375

            // console.log(3333,window.innerWidth,bl);


            if (scrollTop > 100 * bl) {
                this.p1=true
            } else {
                this.p1=false
            }
             if (scrollTop > 200 * bl) {
                this.p2=true
            } else {
                this.p2=false
            }
             if (scrollTop > 300 * bl) {
                this.p3=true
            } else {
                this.p3=false
            }
             if (scrollTop > 400 * bl) {
                this.p4=true
            } else {
                this.p4=false
            }

             if (scrollTop > 550 * bl) {
                this.tips1=true
            } else {
                this.tips1=false
            }

            if (scrollTop > 650 * bl) {
                this.p5=true
            } else {
                this.p5=false
            }

            if (scrollTop > 850 * bl) {
                this.p6=true
            } else {
                this.p6=false
            }

             if (scrollTop > 1250 * bl) {
                this.tips2=true
            } else {
                this.tips2=false
            }

            if (scrollTop > 1350 * bl) {
                this.p7=true
            } else {
                this.p7=false
            }

            if (scrollTop > 1400 * bl) {
                this.p8=true
            } else {
                this.p8=false
            }

            if (scrollTop > 1600 * bl) {
                this.p9=true
            } else {
                this.p9=false
            }

              if (scrollTop > 1700 * bl) {
                this.tips3=true
            } else {
                this.tips3=false
            }

             if (scrollTop > 1850 * bl) {
                this.p10=true
            } else {
                this.p10=false
            }
              if (scrollTop > 2230 * bl) {
                this.p11=true
            } else {
                this.p11=false
            }
              if (scrollTop > 2600 * bl) {
                this.p12=true
            } else {
                this.p12=false
            }

              if (scrollTop > 3100 * bl) {
                this.tips4=true
                setTimeout(() => {
                    this.tips5=true
                }, 500);
            } else {
                this.tips4=false
                this.tips5=false
            }

             if (scrollTop > 3250 * bl) {
                this.p13=true
                  setTimeout(() => {
                    this.p14=true
                }, 500);
            } else {
                this.p13=false
                this.p14=false
            }

               if (scrollTop > 3400 * bl) {
                this.tips6=true
            } else {
                this.tips6=false
            }

             if (scrollTop > 3850 * bl) {
                this.p15=true
            } else {
                this.p15=false
            }

             if (scrollTop > 4350 * bl) {
                this.p16=true
            } else {
                this.p16=false
            }

              if (scrollTop > 4550 * bl) {
                this.tips7=true
            } else {
                this.tips7=false
            }

             if (scrollTop > 4820 * bl) {
                this.p17=true
                  setTimeout(() => {
                    this.p18=true
                }, 500);
            } else {
                this.p17=false
                this.p18=false
            }

               if (scrollTop > 5050 * bl) {
                this.tips8=true
            } else {
                this.tips8=false
            }

              if (scrollTop > 5250 * bl) {
                this.p19=true
            } else {
                this.p19=false
            }

             if (scrollTop > 5520 * bl) {
                this.tips9=true
            } else {
                this.tips9=false
            }

              if (scrollTop > 5700 * bl) {
                this.p20=true
                  setTimeout(() => {
                    this.p21=true
                }, 500);
            } else {
                this.p20=false
                this.p21=false
            }

             if (scrollTop > 6100 * bl) {
                this.tips10=true
            } else {
                this.tips10=false
            }

              if (scrollTop > 6300 * bl) {
                this.tips11=true
                setTimeout(() => {
                    this.p22=true
                    setTimeout(() => {
                        this.p23=true
                    }, 500);
                }, 500);
                
            } else {
                this.tips11=false
                this.p22=false
                this.p23=false
            }

               if (scrollTop > 6600 * bl) {
                this.tips12=true
            } else {
                this.tips12=false
            }

               if (scrollTop > 7030 * bl) {
                this.tips13=true
            } else {
                this.tips13=false
            }

               if (scrollTop > 7280 * bl) {
                this.p24=true
            } else {
                this.p24=false
            }

             if (scrollTop > 7450 * bl) {
                this.tips14=true
            } else {
                this.tips14=false
            }
             if (scrollTop > 7800 * bl) {
                this.tips15=true
            } else {
                this.tips15=false
            }

              if (scrollTop > 7920 * bl) {
                this.p25=true
                setTimeout(() => {
                    this.p26=true
                    setTimeout(() => {
                        this.p27=true
                    }, 500);
                }, 500);
                
            } else {
                this.p25=false
                this.p26=false
                this.p27=false
            }

               if (scrollTop > 9450 * bl) {
                this.p28=true
                setTimeout(() => {
                    this.p29=true
                }, 1000);
                
            } else {
                this.p28=false
                this.p29=false
            }

             if (scrollTop > 9700 * bl) {
                this.p30=true
            } else {
                this.p30=false
            }



            // 更新——滚动前，滚动条距文档顶部的距离
            this.oldScrollTop = scrollTop;

            //变量windowHeight是可视区的高度
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;

            //滚动条到底部的条件
            if (scrollTop + windowHeight == scrollHeight) {
                //你想做的事情
                console.log("header  你已经到底部了");
            }
            //   if (scrollStep < 0) {
            //     console.log("header 滚动条向上滚动了！");
            //   } else {
            //     console.log("header  滚动条向下滚动了！");
            //   }
            // 判断是否到了最顶部
            if (scrollTop <= 0) {
                console.log("header 到了最顶部")
            }
        },
    },
    mounted() {

        window.addEventListener("scroll", this.scrolling)
        // console.log(document.getElementById("scene").offsetWidth,32);

        setTimeout(() => {
            let audio = document.getElementById("audio");

            if (window.sessionStorage.getItem("music") == "false") {
                this.music = false
                audio.pause();
            } else {


                if (window.sessionStorage.getItem("time") != "null") {

                    audio.currentTime = window.sessionStorage.getItem("time")
                    // audio.play()
                }

                audio.play()

            }
        }, 200);
    },
}
</script>

<style lang="less">
.home {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .homebg {
        width: 100%;
        display: block;
    }

    .music {
        position: fixed;
        top: 15px;
        right: 15px;
        width: 40px;
        z-index: 3;
        transform: rotate(250deg);

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }

    .title {
        position: absolute;
        width: 360px;
        top: 35px;
        left: 10px;
        animation: title-ani 3s ease 1 forwards;

        @keyframes title-ani {
            0% {

                transform: scale(0.1);
                opacity: 0;

            }

            100% {
                transform: scale(1);
                opacity: 1;
            }
        }
    }

    .tobottom {
        position: absolute;
        width: 50px;
        top: 265px;
        right: 15px;
    }

    .tips {
        position: absolute;
        width: 170px;
        top: 300px;
        left: 50%;
        margin-left: -90px;
        animation: tips1-ani 2s ease 1 forwards;

        @keyframes tips1-ani {
            0% {

                top: 320px;
                opacity: 0;

            }

            100% {
                top: 300px;
                opacity: 1;
            }
        }
    }

    .tips2 {
        position: absolute;
        width: 90px;
        top: 460px;
        left: 50%;
        margin-left: -45px;
        animation: tips2-ani 2s ease 1 forwards;

        @keyframes tips2-ani {
            0% {

                top: 480px;
                opacity: 0;

            }

            100% {
                top: 460px;
                opacity: 1;
            }
        }
    }

    .p1 {
        position: absolute;
        width: 155px;
        top: 600px;
        right: 0;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {

                right: -100px;
                opacity: 0;

            }

            100% {
                right: 0;
                opacity: 1;
            }
        }
    }

    .p2 {
        position: absolute;
        width: 190px;
        top: 680px;
        left: 0;
        animation: p2-ani 2s ease 1 forwards;

        @keyframes p2-ani {
            0% {

                left: -100px;
                opacity: 0;

            }

            100% {
                left: 0;
                opacity: 1;
            }
        }
    }

    .p3 {
        position: absolute;
        width: 180px;
        top: 720px;
        right: 0;
        animation: p1-ani 2s ease 1 forwards;

        @keyframes p1-ani {
            0% {

                right: -100px;
                opacity: 0;

            }

            100% {
                right: 0;
                opacity: 1;
            }
        }
    }

    @keyframes p-ani {
        0% {


            opacity: 0;

        }

        100% {

            opacity: 1;
        }
    }

    .p4 {
        position: absolute;
        width: 260px;
        top: 870px;
        left: 0;
        animation: p2-ani 2s ease 1 forwards;

        @keyframes p2-ani {
            0% {

                left: -100px;
                opacity: 0;

            }

            100% {
                left: 0;
                opacity: 1;
            }
        }
    }

    .tips3 {
        position: absolute;
        width: 80px;
        top: 1046px;
        left: 50%;
        margin-left: -38px;
        animation: tips3-ani 2s ease 1 forwards;

        @keyframes tips3-ani {
            0% {

                top: 1066px;
                opacity: 0;

            }

            100% {
                top: 1046px;
                opacity: 1;
            }
        }
    }

    .p5 {
        position: absolute;
        width: 100px;
        top: 1120px;
        left: 120px;
        animation: p-ani 2s ease 1 forwards;
    }

    .p6 {
        position: absolute;
        width: 125px;
        top: 1290px;
        left: 43px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips4 {
        position: absolute;
        width: 100px;
        top: 1685px;
        left: 50%;
        margin-left: -26px;
        animation: tips4-ani 2s ease 1 forwards;

        @keyframes tips4-ani {
            0% {

                top: 1700px;
                opacity: 0;

            }

            100% {
                top: 1685px;
                opacity: 1;
            }
        }
    }

    .p7 {
        position: absolute;
        width: 110px;
        top: 1790px;
        left: 10px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p8 {
        position: absolute;
        width: 140px;
        top: 1840px;
        right: 20px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p9 {
        position: absolute;
        width: 105px;
        top: 2040px;
        left: 110px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips5 {
        position: absolute;
        width: 105px;
        top: 2180px;
        left: 85px;
        animation: tips5-ani 2s ease 1 forwards;

        @keyframes tips5-ani {
            0% {

                top: 2200px;
                opacity: 0;

            }

            100% {
                top: 2180x;
                opacity: 1;
            }
        }
    }

    .p10 {
        position: absolute;
        width: 80px;
        top: 2305px;
        left: 40px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p11 {
        position: absolute;
        width: 245px;
        top: 2580px;
        left: 10px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p12 {
        position: absolute;
        width: 175px;
        top: 3040px;
        left: 65px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips6 {
        position: absolute;
        width: 85px;
        top: 3540px;
        left: 75px;
        animation: tips6-ani 2s ease 1 forwards;

        @keyframes tips6-ani {
            0% {

                top: 3560px;
                opacity: 0;

            }

            100% {
                top: 3540px;
                opacity: 1;
            }
        }
    }

    .tips7 {
        position: absolute;
        width: 160px;
        top: 3600px;
        left: 165px;
        animation: tips7-ani 2s ease 1 forwards;

        @keyframes tips7-ani {
            0% {

                top: 3620px;
                opacity: 0;

            }

            100% {
                top: 3600px;
                opacity: 1;
            }
        }
    }

    .p13 {
        position: absolute;
        width: 70px;
        top: 3660px;
        right: 5px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p14 {
        position: absolute;
        width: 150px;
        top: 3770px;
        left: 38px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips8 {
        position: absolute;
        width: 170px;
        top: 3896px;
        left: 64px;
        animation: tips8-ani 2s ease 1 forwards;

        @keyframes tips8-ani {
            0% {

                top: 3916px;
                opacity: 0;

            }

            100% {
                top: 3896px;
                opacity: 1;
            }
        }
    }

    .p15 {
        position: absolute;
        width: 180px;
        top: 4087px;
        left: 102px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p16 {
        position: absolute;
        width: 95px;
        top: 4735px;
        left: 120px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips9 {
        position: absolute;
        width: 90px;
        top: 4985px;
        left: 135px;
        animation: tips9-ani 2s ease 1 forwards;

        @keyframes tips9-ani {
            0% {

                top: 5005px;
                opacity: 0;

            }

            100% {
                top: 4985px;
                opacity: 1;
            }
        }
    }

    .p17 {
        position: absolute;
        width: 110px;
        top: 5240px;
        left: 5px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p18 {
        position: absolute;
        width: 115px;
        top: 5195px;
        left: 150px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips10 {
        position: absolute;
        width: 120px;
        top: 5500px;
        left: 90px;
        animation: tips10-ani 2s ease 1 forwards;

        @keyframes tips10-ani {
            0% {

                top: 5520px;
                opacity: 0;

            }

            100% {
                top: 5500px;
                opacity: 1;
            }
        }
    }

    .p19 {
        position: absolute;
        width: 175px;
        top: 5670px;
        left: 75px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips11 {
        position: absolute;
        width: 125px;
        top: 5900px;
        left: 45px;
        animation: tips11-ani 2s ease 1 forwards;

        @keyframes tips11-ani {
            0% {

                top: 5920px;
                opacity: 0;

            }

            100% {
                top: 5900px;
                opacity: 1;
            }
        }
    }

    .p20 {
        position: absolute;
        width: 115px;
        top: 6095px;
        left: 205px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p21 {
        position: absolute;
        width: 140px;
        top: 6220px;
        left: 30px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips12 {
        position: absolute;
        width: 110px;
        top: 6525px;
        left: 130px;
        animation: tips12-ani 2s ease 1 forwards;

        @keyframes tips12-ani {
            0% {

                top: 6545px;
                opacity: 0;

            }

            100% {
                top: 6525px;
                opacity: 1;
            }
        }
    }

    .p22 {
        position: absolute;
        width: 110px;
        top: 6730px;
        left: 155px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips13 {
        position: absolute;
        width: 120px;
        top: 6785px;
        left: 50px;
        animation: tips13-ani 2s ease 1 forwards;

        @keyframes tips13-ani {
            0% {

                top: 6805px;
                opacity: 0;

            }

            100% {
                top: 6785px;
                opacity: 1;
            }
        }
    }

    .p23 {
        position: absolute;
        width: 80px;
        top: 6900px;
        left: 10px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips14 {
        position: absolute;
        width: 120px;
        top: 7066px;
        left: 154px;
        animation: tips14-ani 2s ease 1 forwards;

        @keyframes tips14-ani {
            0% {

                top: 7086px;
                opacity: 0;

            }

            100% {
                top: 7066px;
                opacity: 1;
            }
        }
    }

    .tips15 {
        position: absolute;
        width: 200px;
        top: 7436px;
        left: 75px;
        animation: tips15-ani 2s ease 1 forwards;

        @keyframes tips15-ani {
            0% {

                top: 7456px;
                opacity: 0;

            }

            100% {
                top: 7436px;
                opacity: 1;
            }
        }
    }

    .p24 {
        position: absolute;
        width: 95px;
        top: 7625px;
        left: 80px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .tips16 {
        position: absolute;
        width: 200px;
        top: 7855px;
        left: 79px;
        animation: tips16-ani 2s ease 1 forwards;

        @keyframes tips16-ani {
            0% {

                top: 7875px;
                opacity: 0;

            }

            100% {
                top: 7855px;
                opacity: 1;
            }
        }
    }

    .tips17 {
        position: absolute;
        width: 90px;
        top: 8145px;
        left: 135px;
        animation: tips17-ani 2s ease 1 forwards;

        @keyframes tips17-ani {
            0% {

                top: 8165px;
                opacity: 0;

            }

            100% {
                top: 8145px;
                opacity: 1;
            }
        }
    }

    .p25 {
        position: absolute;
        width: 110px;
        top: 8200px;
        left: 110px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p26 {
        position: absolute;
        width: 120px;
        top: 8340px;
        left: 45px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p27 {
        position: absolute;
        width: 135px;
        top: 8470px;
        left: 15px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p28 {
        position: absolute;
        width: 150px;
        top: 9820px;
        left: 190px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p29 {
        position: absolute;
        width: 115px;
        top: 9915px;
        left: 45px;
        animation: p1-ani 2s ease 1 forwards;
    }

    .p30 {
        position: absolute;
        width: 200px;
        top: 10190px;
        right: 13px;
        animation: p1-ani 2s ease 1 forwards;
    }

}
</style>